import { SketchNoteLogoIcon } from '@sketchnote/icons';
import { Button } from '@sketchnote/shared-components';
import Link from 'next/link';
import * as React from 'react';
import { useAuth } from 'src/shared/hooks/use-auth';

export const NoAccessPage = ({
  showLogo = true,
  type = 'file',
}: {
  showLogo?: boolean;
  type?: string;
}) => {
  const authData = useAuth((s) => s.userDetails);
  const orgId = authData?.memberInformation?.organisation?.organisationId;

  return (
    <div className="w-full h-screen flex justify-center overflow-hidden">
      {showLogo && (
        <div className="absolute top-16 left-65">
          <Link href={'https://sketchnote.co/'}>
            <a className="flex items-center">
              <SketchNoteLogoIcon className="text-primary-500 text-4xl" />
              <span className="text-primary-800 font-extraBold ml-4 text-xl">sketchnote</span>
            </a>
          </Link>
        </div>
      )}
      <div className="m-auto w-500 h-auto">
        <div className=" text-center text-gray-500">
          <img
            src="https://res.cloudinary.com/samvibes/image/upload/privatepage.png"
            width="164px"
            height="164px"
            className="mx-auto"
            alt="sign up banner"
          />

          {type === 'organisation' ? (
            <p className="mb-14 text-center text-lg font-bold text-999">
              Oops, you&apos;re not a member of this organization. Contact the admin/inviter for
              access
            </p>
          ) : (
            <>
              <h2 className="mb-14 leading-40 text-center">
                You&apos;ve reached a private {type}!
              </h2>
              <p>Request access to view content on this page</p>
              <Button status="primary" className="pl-8 mt-24 mb-16">
                <Link href={`/w/${orgId}/dashboard`}>Back to my dashboard</Link>
              </Button>
            </>
          )}

          {type !== 'organisation' ? (
            <p className="text-sm mb-12">
              You&apos;re currently logged in from&nbsp;
              <span className="text-gray-700">{authData?.email}</span>
            </p>
          ) : (
            <></>
          )}
          <p className="text-gray-500 mb-34 text-center text-xs">
            <Link href={'https://sketchnote.co/forms/636cf35095845f348e2221c8'}>
              <a target="_blank">Contact support</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
